import React from 'react';
import { TaskFile } from '../../types';
import { ImageIcon, FileIcon } from '../../components/icons/Icons';
import { FILE_PATTERNS } from '../../constants';

interface AttachmentPreviewModalProps {
  attachment: TaskFile | null;
  onClose: () => void;
}

export const AttachmentPreviewModal: React.FC<AttachmentPreviewModalProps> = ({ attachment, onClose }) => {
  if (!attachment) return null;
  const isImage = FILE_PATTERNS.IMAGE.test(attachment.fileName);
  const isPdf = FILE_PATTERNS.PDF.test(attachment.fileName);
  const hasUrl = !!attachment.publicUrl;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={isPdf && hasUrl ? { maxWidth: '90vw', width: '900px' } : undefined}>
        <div className="modal-header">
          <h3 className="modal-title">{attachment.fileName}</h3>
          <button className="modal-close-btn" onClick={onClose}>&#10005;</button>
        </div>
        <div className="modal-body">
          {isImage && hasUrl ? (
            <img src={attachment.publicUrl} alt={attachment.fileName} className="modal-image" />
          ) : isImage ? (
            <div className="modal-file-preview">
              <ImageIcon size={48} className="modal-icon-blue" />
              <p className="modal-filename">{attachment.fileName}</p>
              <p className="modal-file-hint">Image preview not available</p>
            </div>
          ) : isPdf && hasUrl ? (
            <iframe
              src={attachment.publicUrl}
              title={attachment.fileName}
              className="modal-pdf-iframe"
              style={{ width: '100%', height: '75vh', border: 'none', borderRadius: '8px' }}
            />
          ) : isPdf ? (
            <div className="modal-file-preview">
              <FileIcon size={48} className="modal-icon-red" />
              <p className="modal-filename">{attachment.fileName}</p>
              <p className="modal-file-hint">PDF preview not available</p>
            </div>
          ) : (
            <div className="modal-file-preview">
              <FileIcon size={48} className="modal-icon-blue" />
              <p className="modal-filename">{attachment.fileName}</p>
              {hasUrl ? (
                <a href={attachment.publicUrl} target="_blank" rel="noopener noreferrer" className="modal-download-link">Download file</a>
              ) : (
                <p className="modal-file-hint">File preview not available</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
